/**
 * Created by Administrador on 10/21/2016.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('rulesController', rulesController)
        .controller('newEditRuleController', newEditRuleController)
        .controller('modalApplyFlightRouteController', modalApplyFlightRouteController)
        .controller('deleteRuleController', deleteRuleController)
        .controller('modalApplySaleChannelController', modalApplySaleChannelController);

    rulesController.$inject = ['rules', 'linkService']
    newEditRuleController.$inject = ['ruleId', 'rule', 'datePickerService', '$uibModal', '$timeout', 'passengerTypeService',
        '$translate', 'linkService', 'operationService', 'validationManager', 'ruleService','dateService','$filter'];
    modalApplyFlightRouteController.$inject = ['$uibModalInstance', 'type', 'routeService', 'flightService', 'linkService'];
    deleteRuleController.$inject = ['ruleId', 'rule', 'ruleService', '$uibModalInstance'];
    modalApplySaleChannelController.$inject = ['$uibModalInstance', 'regions', 'type', 'saleChannelService', 'linkService'];

    function rulesController(rules, linkService) {
        var vm = this;

        vm.rules = (rules.data._embedded) ? rules.data._embedded.rules : [];
        vm.linkService = linkService;
        vm.pages = rules.data.page;
    }

    function newEditRuleController(ruleId, rule, datePickerService, $uibModal, $timeout, passengerTypeService, $translate, linkService,
                               operationService, validationManager, ruleService, dateService,$filter) {
        var vm = this;
        var urlTemplateBase = "app/admin/configGeneral/rates/rule/templates/";
        vm.ruleId = ruleId;
        vm.rule = {};
        vm.rule.name = "";
        vm.regulationTemplates = [];
        vm.regulation = {};
        vm.action = "new";
        vm.regulations = getRegulations();
        vm.selectCheckBox = getSelectCheckBox(vm.regulations);

        vm.getSaleChannels = function(saleChannelItems){
            var res = [];
            angular.forEach(saleChannelItems, function (saleChannelItem) {
                 res.push({
                     application: saleChannelItem.application,
                     saleChannelId: saleChannelItem.saleChannelId,
                     region: saleChannelItem._embedded.saleChannel.region,
                     name: saleChannelItem._embedded.saleChannel.name,
                     type: saleChannelItem._embedded.saleChannel.type
                });
             });
            return res;
        }

        vm.addToRegulations = function(name, regulation){
            switch (name){
                case "dateRule":
                    vm.regulation.dates = {
                        endSaleTicket: (regulation!=null && regulation.endSaleTicket!=null) ? dateService.getDateByDateZone(regulation.endSaleTicket) : null,
                        endTripDate: (regulation != null && regulation.endTripDate!=null) ? dateService.getDateByDateZone(regulation.endTripDate) : null,
                        publicationDate: (regulation != null && regulation.publicationDate!=null) ? dateService.getDateByDateZone(regulation.publicationDate) : new Date(),
                        startSaleTicket: (regulation != null && regulation.startSaleTicket!=null) ? dateService.getDateByDateZone(regulation.startSaleTicket) : null,
                        startTripDate: (regulation != null && regulation.startTripDate!=null) ? dateService.getDateByDateZone(regulation.startTripDate) : null,
                        travelConclusion: (regulation != null && regulation.travelConclution!=null) ? dateService.getDateByDateZone(regulation.travelConclution) : null,
                        type: "string",
                        checkBoxDays: vm.getCheckBoxDays(regulation),
                        weekDays: [
                            {id: 1, name: "global.weekdays.monday.name", initials: "global.weekdays.monday.initials"},
                            {id: 2, name: "global.weekdays.tuesday.name", initials: "global.weekdays.tuesday.initials"},
                            {id: 3, name: "global.weekdays.wednesday.name", initials: "global.weekdays.wednesday.initials"},
                            {id: 4, name: "global.weekdays.thursday.name", initials: "global.weekdays.thursday.initials"},
                            {id: 5, name: "global.weekdays.friday.name", initials: "global.weekdays.friday.initials"},
                            {id: 6, name: "global.weekdays.saturday.name", initials: "global.weekdays.saturday.initials"},
                            {id: 7, name: "global.weekdays.sunday.name", initials: "global.weekdays.sunday.initials"}
                        ]
                    };
                    break;
                case "passengerTypeRule":
                    vm.getPassengerTypes(regulation);
                    vm.regulation.passengerTypes = [];
                    break;
                case "flightRouteRule":
                    vm.regulation.flightRoutes = {
                        flightRoutes: (regulation != null) ? (regulation._embedded? vm.getFlightRoutes(regulation._embedded.flightRuleItems):[]) : []
                    };
                    vm.regulation.flightRoutes.flightRoutes = $filter('orderBy')(vm.regulation.flightRoutes.flightRoutes ,'originIataCode');
                    break;
                case "bookingTicketingRule":
                    vm.regulation.bookingTicketing = {
                        minSaleBeforeDeparture: (regulation != null) ? regulation.minSaleBeforeDeparture : null,
                        allowsBook: (regulation != null) ? regulation.allowsBook : false,
                        minBookBeforeDeparture: (regulation != null) ? regulation.minBookBeforeDeparture : null,
                        minBookAfterDeparture: (regulation != null) ? regulation.minBookAfterDeparture : null,
                        timeOfValidity1: (regulation != null) ? regulation.timeOfValidity1 : null,
                        timeOfValidity2: (regulation != null) ? regulation.timeOfValidity2 : null,
                        waitingList: (regulation != null) ? regulation.waitingList : null
                    };
                    break;
                case "minMaxStayRule":
                    vm.regulation.minMaxStay = {
                        noLessThanType: (regulation != null) ? regulation.noLessThanType : null,
                        noLessThanValue: (regulation != null) ? regulation.noLessThanValue : null,
                        noLessThanValueRequired: (regulation != null) ? false : true,
                        noLessThanTypeRequired: (regulation != null) ? false : true,
                        noMoreThanType: (regulation != null) ? regulation.noMoreThanType : null,
                        noMoreThanValue: (regulation != null) ? regulation.noMoreThanValue : null,
                        noMoreThanValueRequired: (regulation != null) ? false : true,
                        noMoreThanTypeRequired: (regulation != null) ? false : true
                    };
                    break;
                case "saleChannelRule":
                    vm.regulation.saleChannel = {
                        saleChannels: (regulation != null) ? vm.getSaleChannels(regulation._embedded.saleChannelItems) : [],
                        promotionalCode: (regulation != null) ? regulation.promotionalCode : null
                    }
                    break;
                case "temporalityRule":
                    vm.regulation.temporalities = (regulation != null) ? vm.getTemporalities(regulation) : [];
                    break;
                case "penaltyRule":
                    vm.regulation.penalties = [];
                    if(regulation != null){
                        vm.getPenalties(regulation)
                    }else{
                        vm.getPenalties([]);
                    }
                    break;
            }
        }

        vm.removeToRegulations = function(name){
            switch (name){
                case "dateRule":
                    vm.regulation.dates = undefined;
                    break;
                case "passengerTypeRule":
                    vm.regulation.passengerTypes = undefined;
                    break;
                case "flightRouteRule":
                    vm.regulation.flightRoutes = undefined;
                    break;
                case "bookingTicketingRule":
                    vm.regulation.bookingTicketing = undefined;
                    break;
                case "minMaxStayRule":
                    vm.regulation.minMaxStay = undefined;
                    break;
                case "saleChannelRule":
                    vm.regulation.saleChannel = undefined;
                    break;
                case "temporalityRule":
                    vm.regulation.temporalities = undefined;
                    break;
                case "penaltyRule":
                    vm.regulation.penalties = undefined;
                    break;
            }

        }

        vm.getCheckBoxDays = function (regulation) {
            var res = {"1": true, "2": true, "3": true, "4": true, "5": true, "6": true, "7": true};
            if(regulation != null){
                res = {"1": false, "2": false, "3": false, "4": false, "5": false, "6": false, "7": false};
                var days = regulation.days;
                var splitDays = days.split(",");
                for(var i = 0; i < splitDays.length; i++){
                    res[splitDays[i]] = true;
                }
            }
            return res;
        }

        vm.getCheckBoxFlightTypes = function (flightRoute) {
            var res = {"1": false, "2": false, "3": false};
            if(flightRoute != null){
                if(flightRoute.unscaled){
                    res[1] = true;
                }
                if(flightRoute.withScale) {
                    res[2] = true;
                }
                if(flightRoute.connection){
                    res[3] = true;
                }
            }
            return res;
        }

        vm.getPassengerTypes = function(regulation){
            passengerTypeService.getPassengerTypes()
                .then(function(response){
                    var passengerTypes = (response.data._embedded) ? response.data._embedded.passengerTypes : [];
                    vm.passengerTypes = passengerTypes;
                    vm.idsPassenger = (regulation != null) ? idsPassenger(regulation, linkService) : [];
                    vm.passengerTypesTree = refactorJson(passengerTypes, vm.idsPassenger, $translate, linkService);
                    vm.treeConfig = getTreeConfig();
                });
        }

        vm.getPenalties = function(penaltyItems){
            operationService.getOperations(true)
                .then(function(response){
                    var operations = response;
                    angular.forEach(operations, function(operation){

                        var penaltyItem = {};
                        if(penaltyItems.length > 0){
                            penaltyItem = getPenaltyItem(penaltyItems, operation, linkService);
                        }
                        vm.regulation.penalties.push({
                            code: (penaltyItem.code) ? penaltyItem.code : operation.code,
                            description: operation.descriptionLang,
                            amount: (penaltyItem.amount) ? penaltyItem.amount : 0,
                            fixedAmount: (penaltyItem.fixedAmount) ? penaltyItem.fixedAmount : operation.fixAmount,
                            penaltyId: linkService.getLinkId(operation._links.self.href),
                            percentage: (penaltyItem.percentage) ? penaltyItem.percentage : operation.percentage,
                            subjectToChange: (penaltyItem.subjectToChange) ? penaltyItem.subjectToChange : false,
                            select: (penaltyItem.penaltyId) ? true : false,
                            type: "string"
                        });
                        vm.checkBoxPenalty[operation.code] = (penaltyItem.penaltyId) ? true : false;
                    });
                });
        }

        vm.getFlightRoutes = function(flightRoutes){
            var res = [];
            angular.forEach(flightRoutes, function (flightRoute) {
                res.push({
                    application: flightRoute.application,
                    destinyIataCode: flightRoute.destinyIataCode,
                    flightId: flightRoute.flightId,
                    originIataCode: flightRoute.originIataCode,
                    routeId: flightRoute.routeId,
                    type: flightRoute.type,
                    unscaled: flightRoute.unscaled,
                    withScale: flightRoute.withScale,
                    connection:flightRoute.connection,
                    checkBoxFlightTypes : vm.getCheckBoxFlightTypes(flightRoute),
                    _embedded: flightRoute._embedded
                });
            });
            return res;
        }

        vm.getTemporalities = function(temporalities){
            var res = [];
            angular.forEach(temporalities, function (temporality) {
                res.push({
                    endPeriod: temporality.endPeriod,
                    startPeriod: temporality.startPeriod,
                    type: ""
                });
            });
            return res;
        }

        if(rule != null){
            vm.action = "edit";
            vm.rule = rule.data;
            vm.rule.name = rule.data.name;
            vm.selectCheckBox = getSelectCheckBoxEdit(vm.selectCheckBox, vm.rule._embedded.regulations);
            angular.forEach(vm.rule._embedded.regulations, function(regulation){
                vm.regulationTemplates.push({
                    name: regulation.type,
                    template: urlTemplateBase + regulation.type + "/" + regulation.type + ".html"
                });

                var typeRule = regulation.type;

                switch (typeRule){
                    case "penaltyRule":
                        typeRule = "penaltyItems";
                        break;
                    case "passengerTypeRule":
                        typeRule = "passengerTypeItems";
                        break;
                    case "temporalityRule":
                        typeRule = "periodDates";
                        break;
                    case "flightRouteRule":
                        typeRule = "flightRouteRule";
                        break;
                }

                vm.addToRegulations(regulation.type, regulation._embedded[typeRule]);
            });
        }

        vm.addRemoveRegulation = function(name, code){
            if(vm.selectCheckBox[code]){
                vm.regulationTemplates.push({
                    name: name,
                    template: urlTemplateBase + name + "/" + name + ".html"
                });
                vm.addToRegulations(name, null);
            }else {
                var pos = vm.regulationTemplatePos(vm.regulationTemplates, name);
                if(pos != -1){
                    vm.regulationTemplates.splice(pos, 1);
                }
                vm.removeToRegulations(name);
            }
        }

        vm.templateUrl = function(name){
            return urlTemplateBase + name + ".html";
        }

        vm.regulationTemplatePos = function(regulationTemplates, name){
            var pos = -1;
            for(var i = 0; i < regulationTemplates.length; i++){
                if(regulationTemplates[i].name == name){
                    pos = i;
                    break;
                }
            }
            return pos;
        }

        vm.deleteToRegulations = function (title) {
            var index = vm.regulationTemplates.indexOf(title);
            if (index > -1) {
                vm.regulationTemplates.splice(index, 1);
            }
        }

        /* Dates */
        vm.currentDate = new Date();
        vm.currentDate.setHours(0,0,0);
        vm.disabledEndTrip = true;
        vm.disabledEndSale = true;
        vm.pickerButtons = datePickerService.pickerButtons();
        vm.dateFormat = 'dd/MM/yyyy';

        vm.dpPublicationDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.dpStartTripDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.currentDate
            }
        };

        vm.dpEndTripDate = {
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.dpTravelConclusion = {
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.dpStartSaleTicket = {
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.currentDate
            }
        };

        vm.dpEndSaleTicket = {
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.dpOpenStatus = {
            'publicationDate': false,
            'startTripDate': false,
            'endTripDate': false,
            'travelConclusion': false,
            'startSaleTicket': false,
            'endSaleTicket': false
        };

        vm.openCalendar = function(date) {
            vm.dpOpenStatus[date] = true;
        };

        vm.eventChangeDate = function(dateType){
            $timeout(function(){
                var dateValue = vm.regulation.dates[dateType];
                if (dateType === 'startTripDate') {
                    if (dateValue !== null) {
                        vm.dpEndTripDate.datepickerOptions.minDate = dateValue;
                        vm.disabledEndTrip = false;
                    } else {
                        vm.disabledEndTrip = true;
                        vm.regulation.dates['endTripDate'] = null;
                    }
                } else if (dateType === 'startSaleTicket') {
                    if (dateValue !== null) {
                        vm.dpEndSaleTicket.datepickerOptions.minDate = dateValue;
                        vm.disabledEndSale = false;
                    } else {
                        vm.disabledEndSale = true;
                        vm.regulation.dates['endSaleTicket'] = null;
                    }
                }
            }, 100);

        }
        /* End dates */

        /* Passenger type */
        vm.passengerTypes = [];
        vm.treeInstance = {};

        /* End passenger type*/

        /* Flight and routes*/
        vm.addApplyFlightRoute = function(type){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/rule/templates/flightRouteRule/modalApplyFlightRoute.html',
                controller: 'modalApplyFlightRouteController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    type: [function() {
                        return type
                    }]
                }
            }).result.then(function(response) {
                if(response.type == "ROUTES" || response.type == "FLIGHTS"){
                    angular.forEach(response.flightRoute, function (res) {
                        if(!existObject(res)) {
                            vm.regulation.flightRoutes.flightRoutes.push(res);
                            vm.regulation.flightRoutes.flightRoutes = $filter('orderBy')(vm.regulation.flightRoutes.flightRoutes ,'originIataCode');
                        }
                    })
                }else{
                    if(!existObject(response)){
                        vm.regulation.flightRoutes.flightRoutes.push(response.flightRoute);
                        vm.regulation.flightRoutes.flightRoutes = $filter('orderBy')(vm.regulation.flightRoutes.flightRoutes ,'originIataCode');
                    }
                }
            }, function() {
                //$state.go('^');
            });
        }

        vm.deleteFlightRoute = function(index){
            vm.regulation.flightRoutes.flightRoutes.splice(index, 1);
        }

        vm.eventHandleFlightRoute = function(indexX, indexY){
            if(indexX==1){
                vm.regulation.flightRoutes.flightRoutes[indexY].unscaled =
                    (vm.regulation.flightRoutes.flightRoutes[indexY].checkBoxFlightTypes[1]) ? true : false;
            }else{
                if(indexX==2){
                    vm.regulation.flightRoutes.flightRoutes[indexY].withScale =
                        (vm.regulation.flightRoutes.flightRoutes[indexY].checkBoxFlightTypes[2]) ? true : false;
                }else{
                    if(indexX==3){
                        vm.regulation.flightRoutes.flightRoutes[indexY].connection =
                            (vm.regulation.flightRoutes.flightRoutes[indexY].checkBoxFlightTypes[3]) ? true : false;
                    }
                }
            }
        }
        /* End flight and routes*/

        /* Booking ticketing */
        /* End booking ticketing */

        /* Temporary */
        vm.addTemporary = function () {
            vm.regulation.temporalities.push({
                endPeriod: "",
                startPeriod: "",
                type: ""
            })
        }

        vm.deleteTemporary = function (index) {
            vm.regulation.temporalities.splice(index, 1);
        }
        /* Temporary */

        /* Minimum and maximum stay */
        //{code: "H", name: "global.dayHourMonths.hours"},
        vm.dayHourMonths = [
            {code: "D", name: "global.dayHourMonths.days"},
            {code: "M", name: "global.dayHourMonths.months"}
        ]
        /* End minimum and maximum stay */

        /* Penalties*/
        vm.operations = [];
        vm.checkBoxPenalty = {};
        vm.eventHandlePenalTy = function(){
            var j = 0;
            angular.forEach(vm.checkBoxPenalty, function (i, val) {
                if(i == false || i == undefined){
                    vm.regulation.penalties[j].select = false
                }else if (i == true){
                    vm.regulation.penalties[j].select = true
                }
                j++;
            });
        }

        vm.eventFixedAmount = function (index) {
            if(vm.regulation.penalties[index].fixedAmount == ""){
                vm.regulation.penalties[index].fixedAmount = 0;
            }
        }

        vm.eventPercentage = function (index) {
            if(vm.regulation.penalties[index].percentage == ""){
                vm.regulation.penalties[index].percentage = 0;
            }
        }
        /* End penalties */

        /* sale channel */
        vm.addApplySaleChannel = function(type){
            $uibModal.open({
                templateUrl: 'app/admin/configGeneral/rates/rule/templates/saleChannelRule/modalApplySaleChannel.html',
                controller: 'modalApplySaleChannelController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    regions: ['saleChannelService', function(saleChannelService){
                        return saleChannelService.getRegionsSaleChannel();
                    }],
                    type: [function() {
                        return type
                    }]
                }
            }).result.then(function(response) {
                angular.forEach(response.saleChannel, function (res) {
                    if(!existSaleChannel(res)) {
                        vm.regulation.saleChannel.saleChannels.push(res)
                    }
                });
            }, function() {
                //$state.go('^');
            });
        }

        function existSaleChannel(response){
            var res = false;
            for(var i=0; i<vm.regulation.saleChannel.saleChannels.length; i++){
                if(vm.regulation.saleChannel.saleChannels[i].saleChannelId == response.saleChannelId){
                    res = true;
                    break;
                }
            }
            return res;
        }

        vm.deleteSaleChannel = function(index){
            vm.regulation.saleChannel.saleChannels.splice(index, 1);
        }

        /* End sale channel*/

        vm.saveRule = function(rule){
            if(vm.regulation.dates){
                vm.rule.rbcDateRule = {
                    "days": getStringDays(vm.regulation.dates.checkBoxDays),
                    "endSaleTicket": vm.regulation.dates.endSaleTicket,
                    "endTripDate": vm.regulation.dates.endTripDate,
                    "publicationDate": vm.regulation.dates.publicationDate,
                    "startSaleTicket": vm.regulation.dates.startSaleTicket,
                    "startTripDate": vm.regulation.dates.startTripDate,
                    "travelConclusion": vm.regulation.dates.travelConclusion,
                    "type": "string"
                }
            }

            if(vm.regulation.passengerTypes){
                var selected_nodes = vm.treeInstance.jstree(true).get_selected();
                vm.rule.rbcPassengerTypeRules = getPassengerTypeIds(selected_nodes);
            }
            if(vm.regulation.flightRoutes){
                vm.rule.rbcFlightRouteRule = vm.regulation.flightRoutes;
                vm.rule.rbcFlightRouteRule.rbcFlightRoutes = vm.regulation.flightRoutes.flightRoutes;
            }

            if(vm.regulation.bookingTicketing){
                vm.rule.rbcBookingTicketingRule = vm.regulation.bookingTicketing
            }

            if(vm.regulation.minMaxStay){
                vm.rule.rbcMinMaxStayRule = vm.regulation.minMaxStay;
            }

            if(vm.regulation.saleChannel){
                vm.rule.rbcSaleChannelRule = vm.regulation.saleChannel;
                vm.rule.rbcSaleChannelRule.rbcSaleChannels = vm.regulation.saleChannel.saleChannels;
            }

            if(vm.regulation.temporalities){
                vm.rule.rbcTemporalityRules = vm.regulation.temporalities;
            }

            if(vm.regulation.penalties){
                vm.rule.rbcPenaltyRules = getTemporalityData(vm.regulation.penalties)
            }

            if(vm.action == "new"){
                ruleService.saveRule(vm.rule);
            }else{
                ruleService.updateRule(vm.ruleId, vm.rule);
            }
        }

        function existObject(response){
            var res = false;
            for(var i=0; i<vm.regulation.flightRoutes.flightRoutes.length; i++){
                if(response.type == "ORIGIN_DESTINY"){
                    if(vm.regulation.flightRoutes.flightRoutes[i].originIataCode == response.flightRoute.originIataCode
                    && vm.regulation.flightRoutes.flightRoutes[i].destinyIataCode == response.flightRoute.destinyIataCode){
                        res = true;
                        break;
                    }
                }else{
                    if(response.type == "ROUTES"){
                        if(vm.regulation.flightRoutes.flightRoutes[i].routeId == response.routeId){
                            res = true;
                            break;
                        }
                    }else{
                        if(response.type == "FLIGHTS"){
                            if(vm.regulation.flightRoutes.flightRoutes[i].flightId== response.flightId){
                                res = true;
                                break;
                            }
                        }
                    }
                }
            }
            return res;
        }

        vm.changesRequiredMinMaxRule = function(name){
            if(name=="noMoreThan"){
                if(parseInt(vm.regulation.minMaxStay.noMoreThanValue)>=0){
                    vm.regulation.minMaxStay.noMoreThanValueRequired = false;
                    vm.regulation.minMaxStay.noMoreThanTypeRequired = true;
                    if(parseInt(vm.regulation.minMaxStay.noLessThanValue)>=0
                        || vm.regulation.minMaxStay.noLessThanType != undefined){
                        vm.regulation.minMaxStay.noLessThanValueRequired = true;
                        vm.regulation.minMaxStay.noLessThanTypeRequired = true;
                    }else{
                        vm.regulation.minMaxStay.noLessThanValueRequired = false;
                        vm.regulation.minMaxStay.noLessThanTypeRequired = false;
                    }
                }else{
                    if(vm.regulation.minMaxStay.noMoreThanType != undefined){
                        vm.regulation.minMaxStay.noMoreThanValueRequired = true;
                        vm.regulation.minMaxStay.noMoreThanTypeRequired = false;
                        if(parseInt(vm.regulation.minMaxStay.noLessThanValue)>=0
                            || vm.regulation.minMaxStay.noLessThanType != undefined){
                            vm.regulation.minMaxStay.noLessThanValueRequired = true;
                            vm.regulation.minMaxStay.noLessThanTypeRequired = true;
                        }else{
                            vm.regulation.minMaxStay.noLessThanValueRequired = false;
                            vm.regulation.minMaxStay.noLessThanTypeRequired = false;
                        }
                    }else{
                        if(parseInt(vm.regulation.minMaxStay.noLessThanValue)>=0
                            || vm.regulation.minMaxStay.noLessThanType != undefined){
                            vm.regulation.minMaxStay.noMoreThanValueRequired = false;
                            vm.regulation.minMaxStay.noMoreThanTypeRequired = false;
                            vm.regulation.minMaxStay.noLessThanValueRequired = true;
                            vm.regulation.minMaxStay.noLessThanTypeRequired = true;
                        }else{
                            vm.regulation.minMaxStay.noMoreThanValueRequired = true;
                            vm.regulation.minMaxStay.noMoreThanTypeRequired = true;
                            vm.regulation.minMaxStay.noLessThanValueRequired = true;
                            vm.regulation.minMaxStay.noLessThanTypeRequired = true;
                        }
                    }
                }
            }else{
                if(parseInt(vm.regulation.minMaxStay.noLessThanValue)>=0){
                    vm.regulation.minMaxStay.noLessThanValueRequired = false;
                    vm.regulation.minMaxStay.noLessThanTypeRequired = true;
                    if(parseInt(vm.regulation.minMaxStay.noMoreThanValue)>=0
                        || vm.regulation.minMaxStay.noMoreThanType != undefined){
                        vm.regulation.minMaxStay.noMoreThanValueRequired = true;
                        vm.regulation.minMaxStay.noMoreThanTypeRequired = true;
                    }else{
                        vm.regulation.minMaxStay.noMoreThanValueRequired = false;
                        vm.regulation.minMaxStay.noMoreThanTypeRequired = false;
                    }
                }else{
                    if(vm.regulation.minMaxStay.noLessThanType != undefined){
                        vm.regulation.minMaxStay.noLessThanValueRequired = true;
                        vm.regulation.minMaxStay.noLessThanTypeRequired = false;
                        if(parseInt(vm.regulation.minMaxStay.noMoreThanValue)>=0
                            || vm.regulation.minMaxStay.noMoreThanType != undefined){
                            vm.regulation.minMaxStay.noMoreThanValueRequired = true;
                            vm.regulation.minMaxStay.noMoreThanTypeRequired = true;
                        }else{
                            vm.regulation.minMaxStay.noMoreThanValueRequired = false;
                            vm.regulation.minMaxStay.noMoreThanTypeRequired = false;
                        }
                    }else{
                        if(parseInt(vm.regulation.minMaxStay.noMoreThanValue)>=0
                            || vm.regulation.minMaxStay.noMoreThanType != undefined){
                            vm.regulation.minMaxStay.noMoreThanValueRequired = true;
                            vm.regulation.minMaxStay.noMoreThanTypeRequired = true;
                            vm.regulation.minMaxStay.noLessThanValueRequired = false;
                            vm.regulation.minMaxStay.noLessThanTypeRequired = false;
                        }else{
                            vm.regulation.minMaxStay.noMoreThanValueRequired = true;
                            vm.regulation.minMaxStay.noMoreThanTypeRequired = true;
                            vm.regulation.minMaxStay.noLessThanValueRequired = true;
                            vm.regulation.minMaxStay.noLessThanTypeRequired = true;
                        }
                    }
                }
            }
        }
    }

    function deleteRuleController(ruleId, rule, ruleService, $uibModalInstance) {
        var vm = this;

        vm.name = rule.data.name;

        vm.deleteRule = function () {
            ruleService.deleteRule(ruleId)
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function modalApplyFlightRouteController($uibModalInstance, type, routeService, flightService, linkService){
        var vm = this;
        vm.linkService = linkService;
        vm.routesCheckBox = {};
        vm.flightRoute = {
            type: "ORIGIN_DESTINY"
        }

        vm.dateFormat = 'dd/MM/yyyy';

        vm.dpOpenStatus = {
            flightDate : false
        }

        vm.dpFlightRoute = {
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            }
        };

        vm.routes = [];
        vm.routeIds = [];
        vm.routesSelect = [];
        vm.routeId = "";
        vm.origin = null;
        vm.destiny = null;

        vm.flightsCheckBox = {};
        vm.flights = [];

        vm.eventChangeOption = function(type){
            vm.flightRoute.origin = null;
            vm.flightRoute.destiny = null;
        }

        vm.getRoutesByOriginDestinyIata = function(origin, destiny){
            if((origin != null || origin != undefined) && (destiny != null && destiny != undefined)){
                routeService.getRoutesByOriginDestinyIata(origin, destiny)
                    .then(function(response){
                        vm.routes = (response.data._embedded) ? response.data._embedded.routes : [];
                        angular.forEach(vm.routes, function(route){
                            vm.routesCheckBox[vm.linkService.getLinkId(route._links.self.href)] = false;
                        });
                    })
            }
        }

        vm.onSegmentRoute = function (segmentRoute, isOriginDestiny, index) {
            if (segmentRoute == undefined) return;
            if (!isOriginDestiny) {
                vm.origin = segmentRoute._embedded.airports[0];
            } else {
                vm.destiny = segmentRoute._embedded.airports[0];
            }
        }

        vm.addFlightRoute = function(isValid, flightRoute){
            if(isValid){
                var resModal;
                if(vm.flightRoute.type == "ORIGIN_DESTINY"){
                    resModal = {
                        application: type,
                        destinyIataCode: flightRoute.destiny,
                        flightId: 0,
                        originIataCode: flightRoute.origin,
                        routeId: 0,
                        type: flightRoute.type,
                        unscaled: false,
                        withScale: false,
                        connection: false,
                        checkBoxFlightTypes : {"1": false, "2": false, "3": false},
                        _embedded: {}
                    };
                }else if(vm.flightRoute.type == "ROUTES"){
                    var dataRoutes = [];
                    angular.forEach(vm.routes, function(route){
                        var routeId = vm.linkService.getLinkId(route._links.self.href);
                        if(vm.routesCheckBox[routeId] == true){
                            dataRoutes.push({
                                application: type,
                                destinyIataCode: "",
                                flightId: 0,
                                originIataCode: "",
                                routeId: parseInt(routeId),
                                type: flightRoute.type,
                                unscaled: false,
                                withScale: false,
                                connection: false,
                                checkBoxFlightTypes : {"1": false, "2": false, "3": false},
                                _embedded: {
                                    route: route
                                }
                            });
                        }
                    });
                    resModal = dataRoutes;
                }else if(vm.flightRoute.type == "FLIGHTS"){
                    var dataRoutes = [];
                    angular.forEach(vm.flights, function(flight){
                        var flightId = vm.linkService.getLinkId(flight._links.self.href);
                        if(vm.flightsCheckBox[flightId] == true){
                            dataRoutes.push({
                                application: type,
                                destinyIataCode: "",
                                flightId: parseInt(flightId),
                                originIataCode: "",
                                routeId: 0,
                                type: flightRoute.type,
                                unscaled: false,
                                withScale: false,
                                connection: false,
                                checkBoxFlightTypes : {"1": false, "2": false, "3": false},
                                _embedded: {
                                    flight: flight
                                }
                            });
                        }
                    });
                    resModal = dataRoutes;
                }
                $uibModalInstance.close({flightRoute: resModal, type: flightRoute.type});
            }
        }

        vm.addApplyToNoApply = function(route, id){
            if(vm.routesCheckBox[id] == true){
                vm.routeIds.push(id)
                /*vm.routesSelect.push({
                    route:
                })*/
            }else if(vm.routesCheckBox[id] == false || vm.routesCheckBox[id] == undefined){
                var pos = vm.routeIds.indexOf(id);
                vm.routeIds.splice(pos, 1);
            }

            for(var i = 0; i < vm.routeIds.length; i++){
                if(i == 0){
                    vm.routeId = vm.routeIds[i];
                }else{
                    vm.routeId = vm.routeId + "," + vm.routeIds[i];
                }
            }
            vm.flightRoute.routeId  = vm.routeId;
        }

        vm.routeRequire = function(routeId){
            var res = true;
            if(routeId == "" || routeId == undefined || routeId == null){
                res = false;
            }
            return res;
        }

        vm.getFlightDate = function(date){
            if(date != undefined){
                var dateTime = date.getTime();
                flightService.getFlightsFromDate(dateTime)
                    .then(function(response){
                        vm.flights = (response.data._embedded) ? response.data._embedded.flights : [];
                        angular.forEach(vm.flights, function(flight){
                            vm.flightsCheckBox[vm.linkService.getLinkId(flight._links.self.href)] = false;
                        });
                    });
            }
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.openCalendar = function(date) {
            vm.dpOpenStatus[date] = true;
        };
    }

    function getPenaltyItem(penaltyItems, operation, linkService){
        var res = {};
        for(var i = 0; i < penaltyItems.length; i++){
            if(parseInt(linkService.getLinkId(operation._links.self.href)) == penaltyItems[i].penaltyId){
                res = penaltyItems[i];
                break;
            }
        }
        return res;
    }

    function getStringDays(checkBoxDays){
        var days = "";
        for(var i = 1; i <= 7; i++){
            if(checkBoxDays[i] == true){
                days = days + i + ",";
            }
        }
        return days;
    }

    function getPassengerTypeIds(dataIds){
        var res = [];
        for(var i = 0; i < dataIds.length; i++){
            if(dataIds[i] != "2000" && dataIds[i] != "2001"){
                res.push({
                    "passengerTypeId": parseInt(dataIds[i])
                });
            }
        }
        return res;
    }

    function getTemporalityData(penalties){
        var res = [];
        angular.forEach(penalties, function (penalty) {
            if(penalty.select == true){
                res.push({
                    "amount": penalty.amount,
                    "fixedAmount": penalty.fixedAmount,
                    "penaltyId": penalty.penaltyId,
                    "percentage": penalty.percentage,
                    "subjectToChange": penalty.subjectToChange,
                    "type": "string",
                    "code": penalty.code
                })
            }
        });
        return res;
    }

    function refactorJson(passengerTypes, idsPassenger, $translate, linkService){
        var data = [];

        data.push({"id": 2000, "parent": "#", "text": $translate.instant("air.passengerType.adults"), "state": { "opened": true }});
        data.push({"id": 2001, "parent": "#", "text": $translate.instant("air.passengerType.infants"), "state": { "opened": true }});

        angular.forEach(passengerTypes, function(passengerType){
            var parent = 0;
            if(passengerType.group == "adult"){
                parent = 2000;
            }else{
                parent = 2001;
            }

            var stateData = { "opened": true };

            if(idsPassenger.length > 0){
                if(idsPassenger.indexOf(linkService.getLinkId(passengerType._links.self.href)) != -1){
                    stateData = {"opened": true, "selected" : true};
                }
            }

            data.push({
                "id": linkService.getLinkId(passengerType._links.self.href),
                "parent": parent,
                "text": $translate.instant(passengerType.lang),
                "state": stateData
            });
        });
        return data;
    }

    function idsPassenger(passengerTypeItems, linkService){
        var ids = [];
        angular.forEach(passengerTypeItems, function(passengerTypeItem){
            ids.push(linkService.getLinkId(passengerTypeItem._links.self.href));
        });
        return ids;
    }

    function getTreeConfig(){
        return {
            core : {
                multiple : true,
                animation: true,
                error : function(error) {
                    $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback : true,
                worker : true,
                themes: {
                    "icons": false
                }
            },
            plugins : ['checkbox']
        }
    }

    function getSelectCheckBox(regulations){
        var selectCheckBox = {};
        angular.forEach(regulations, function(regulation){
            selectCheckBox[regulation.code] = false;
        });
        return selectCheckBox;
    }

    function getSelectCheckBoxEdit(selectCheckBox, regulations){
        angular.forEach(regulations, function(regulation){
            selectCheckBox[regulation.type] = true;
        });
        return selectCheckBox;
    }

    function getRegulations(){
        return [
            {id: 1, code: "dateRule", name: "dateRule", label: "air.rule.table.regulationsNames.dateRule"},
            {id: 3, code: "flightRouteRule", name: "flightRouteRule", label: "air.rule.table.regulationsNames.flightRouteRule"},
            {id: 4, code: "bookingTicketingRule", name: "bookingTicketingRule", label: "air.rule.table.regulationsNames.bookingTicketingRule"},
            {id: 5, code: "temporalityRule", name: "temporalityRule", label: "air.rule.table.regulationsNames.temporalityRule"},
            {id: 6, code: "minMaxStayRule", name: "minMaxStayRule", label: "air.rule.table.regulationsNames.minMaxStayRule"},
            {id: 7, code: "penaltyRule", name: "penaltyRule", label: "air.rule.table.regulationsNames.penaltyRule"}
            //{id: 8, code: "saleChannelRule", name: "saleChannelRule", label: "air.rule.table.regulationsNames.saleChannelRule"}
        ];
    }

    function modalApplySaleChannelController($uibModalInstance, regions, type, saleChannelService, linkService){
        var vm = this;
        vm.linkService = linkService;
        vm.saleChannel = {}
        vm.saleChannelsCheckBox = {};
        vm.saleChannels = [];
        vm.regions =  regions;

        vm.addSaleChannel = function(isValid, saleChannel){
            if(isValid){
                var resModal;

                var dataRoutes = [];
                angular.forEach(vm.saleChannels, function(saleChannel){
                    var saleChannelId = vm.linkService.getLinkId(saleChannel._links.self.href);
                    if(vm.saleChannelsCheckBox[saleChannelId] == true){
                        dataRoutes.push({
                            application: type,
                            saleChannelId: parseInt(saleChannelId),
                            name: saleChannel.name,
                            region: saleChannel.region,
                            type: saleChannel.type,
                            _embedded: {
                                saleChannel: saleChannel
                            }
                        });
                    }
                });
                resModal = dataRoutes;

                $uibModalInstance.close({saleChannel: resModal, type: saleChannel.type});
            }
        }

        vm.changesRequiredRegion = function(name){
            saleChannelService.getSaleChannelGroupsByRegion(name)
                .then(function(response){
                    vm.saleChannels = response;
                    angular.forEach(vm.saleChannels, function(saleChannel){
                        vm.saleChannelsCheckBox[vm.linkService.getLinkId(saleChannel._links.self.href)] = false;
                    });
                });
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
